module.exports = __webpack_public_path__ + "img/up.3e5c0827.png";